const LAUNCH_CAMPAIGN_MODAL_TEST_IDS = {
  LAUNCH_CAMPAIGN_MODAL: 'launch-campaign-modal',
  LAUNCH_CAMPAIGN_MODAL__PRIMARY_BUTTON:
    'launch-campaign-modal__primary-button',
};

export default LAUNCH_CAMPAIGN_MODAL_TEST_IDS;
